import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './menu-item.magic.css.js';
import script from './menu-item.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.link)?_c('li',_vm._b({},'li',_vm.$filteredAttrs,false),[_c('magic-router-link',{staticClass:"menu-item",class:{ 'is-active': _vm.isActive },attrs:{"to":_vm.link,"part":_vm.$p('menu-item', { 'is-active': _vm.isActive })}},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"action",attrs:{"part":"action"}},[(_vm.badge)?_c('magic-ui-badge',{staticClass:"badge--menu-item"},[_vm._v("\n                "+_vm._s(_vm.badgeText)+"\n            ")]):_vm._e(),_vm._v(" "),_c('magic-ui-icon',{staticClass:"icon",attrs:{"name":"right-arrow","part":"icon"}})],1)],2)],1):_c('li',_vm._b({staticClass:"menu-item",class:{ 'is-active': _vm.isActive },attrs:{"part":_vm.$p('menu-item', { 'is-active': _vm.isActive })}},'li',_vm.$filteredAttrs,false),[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"action",attrs:{"part":"action"}},[(_vm.badge)?_c('magic-ui-badge',{staticClass:"badge--menu-item"},[_vm._v("\n            "+_vm._s(_vm.badgeText)+"\n        ")]):_vm._e(),_vm._v(" "),_c('magic-ui-icon',{staticClass:"icon",attrs:{"name":"right-arrow","part":"icon"}})],1)],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-4dcae088_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-4dcae088";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
